import React from 'react'
import { Link } from 'react-router-dom'
import Translate from '../../i18n/Translate'
import { useTranslation } from 'react-i18next'
import { useInView } from 'react-intersection-observer'


const GoFAQs = () => {

    const { t } = useTranslation();

    const [btnRef, inView] = useInView({
        triggerOnce: false,
        threshold: .5,
        delay: 500,
    });


    return (
        <section className="incoming-home__go-faqs">
            <div className="go-faqs">
                <h2>
                    <Translate langkey="home.faqs.title"/>
                </h2>
                <p>
                    <Translate langkey="home.faqs.copy"/>
                </p>
                <Link to={`${t("routes.faqs")}`} className={`go-faqs__btn animate slide-up ${inView ? 'in-view': ''}`} ref={btnRef}>
                    <span><Translate langkey="home.faqs.cta_text"/></span>
                </Link>
            </div>
        </section>
    )
}

export default GoFAQs
